exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-text[data-v-2a9ccc07] {\n  color: red;\n  display: block;\n}\n.b-0[data-v-2a9ccc07] {\n  border: none !important;\n  margin-bottom: 0 !important;\n}\n@media screen and (min-width: 896px) {\n.form-group[data-v-2a9ccc07] {\n    padding: 0;\n}\n.form-control[data-v-2a9ccc07] {\n    font-size: 16px;\n}\n}\n", ""]);

// exports
